import React from 'react';
import { useParams } from 'react-router';

import LoadingScreen from 'src/components/LoadingScreen';
import useGetRequest from 'src/hooks/useGetRequest';

import Overview from './Dashboard';
import Loader from '../../../../components/Loader';

const ViewEngagement = () => {
  const { engagementId } = useParams();
  const { result: engagement, isLoading } = useGetRequest({
    url: `/automatic/engagements/${engagementId}/visit/`,
    deps: [engagementId]
  });

  if (isLoading) return <Loader />;

  return <Overview engagement={engagement} />;
};

export default ViewEngagement;
